export interface IAuthPermissions {
	can_edit_cattle_groups: boolean
	can_edit_cattle_quantity_group: boolean
	can_edit_cattle_quantity_main: boolean
	can_edit_feedplans: boolean
	can_export_feedplans: boolean
	can_edit_rations: boolean
	can_manage_permissions: boolean
	can_manage_users: boolean
	can_view_cattle_groups: boolean
	can_view_feedplans: boolean
	can_view_foodtable_main: boolean
	can_view_rations: boolean
	can_view_analytics: boolean

	license_fatness: boolean
	license_food_table: boolean
	license_identification: boolean
	license_limpness: boolean
	license_milking_process_check: boolean
}

export interface IAvailableRolelist {
	id: number
	title: string
	description?: string
	is_basic?: boolean
	perms_list?: IPermissionList[]
}
export interface IPermissionList {
	name: string
	title: string
	description: string
	parent: string
}

export interface IAuthResponse {
	auth_token?: string
	access: string
	refresh: string
	detail?: string
	current_password?: string[]
}

export interface IPassword {
	current_password?: string[]
}

export interface IAuthState {
	apiToken: string | undefined | null
	refreshToken: string | undefined | null
	authRequest: boolean
	authError: string | undefined
	authRejected?: boolean
	non_field_errors?: string | undefined
	passwordError?: string
	passwordUpdated?: boolean
	permissions: IAuthPermissions
	loading: boolean
}

export interface IAuthProvider {
	children?:
		| React.ReactNode
		| React.ReactNode[]
		| JSX.Element
		| JSX.Element[]
		| React.ReactElement
}

export interface IUserData {
	id?: number
	username: string
	position?: string
	role?: number
	role_title?: string
	email: string
	firstname: string
	lastname: string
	superuser: boolean
	mobile_phone?: string
	is_active: boolean
	session_count?: number
	company?: IUserCompany
	isFatnessExpired?: boolean
	isFoodTableExpired?: boolean
	isIdentificationExpired?: boolean
	isMilkingProcessExpired?: boolean
	isLamenessExpired?: boolean
	avatar?: any
	avatarPreview?: any
}

export interface ILicenseItem {
	license_name: string
	license_codename: LicensesType
	license_features: string
	license_num: string
	barn_title: string | null
	head_count: number | null
	hardware_module: string
	start_dt: number
	until_dt: number
}

export enum LicensesType {
	FOOD_TABLE = 'license_food_table',
	LAMENESS = 'license_limpness',
	FATNESS = 'license_fatness',
	IDENTIFICATION = 'license_identification',
	MILKING_PROCESS = 'license_milking_process_check',
}
export interface IUserCompany {
	id: number
	title: string
	dairy_integration?: null | string
	food_integration?: null | string
	herd_integration?: null | string
	licenses?: {
		license_codename: LicensesType
		license_name: string
		start_dt: number
		until_dt: number
	}[]
	am_period_end?: string
	am_period_start?: string
	night_period_end?: string
	night_period_start?: string
	pm_period_end?: string
	pm_period_start?: string
}

export interface IUserSlice {
	availableRoles: IAvailableRolelist[]
	availableRolesPending: boolean
	rolesError?: string
	detail?: string
	userDataPending: boolean
	userDataError?: string
	userData?: IUserData
	usersList?: IUserData[]
}
